<template>
  <div class="text-to-textarea">
    <div v-if="!editMode && string !== ''" @dblclick="onEditMode" class="text-to-textarea__text">{{ string }}</div>
		<div v-if="!editMode && string === ''" @dblclick="onEditMode" class="text-to-textarea__text empty">текст комментария</div>
    <div v-if="editMode" ref="textarea" class="text-to-textarea__textarea">
      <b-textarea v-model="string"></b-textarea>
    </div>
  </div>
</template>
<script>
export default {
	data () {
		return {
			editMode: false,
			string: '',
			textarea: null
		}
	},
	props: {
		index: {
			type: Number,
			default: null
		},
		text: {
			type: String,
			default: ''
		}
	},
	created () {
		this.string = this.text
	},
	methods: {
		onEditMode (e) {
			this.methodToggle()
			setTimeout(() => {
				let container = e.target
				let textarea = container.querySelector('textarea')
				this.textarea = textarea
				textarea.focus()
				textarea.onfocusout = () => {
					textarea.blur()
					this.methodToggle()
					this.textarea = null
					this.$emit('focusout', {index: this.index, string: this.string})
				}
			}, 200)
		},
		methodToggle () {
			this.editMode = !this.editMode
		}
	}
}
</script>
<style lang="scss">
.text-to-textarea {
	.text-to-textarea__text {
		padding: 0.375rem 0;
		cursor: pointer;
		&.empty {
				text-align: center;
				border: 1px #ccc dashed;
				border-radius: 0.25rem;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/ui/text-to-textarea.vue